<div class="page">
    <div class="page-content">
        <div class="container text-center">
            <div class="row">
                <div class="col-md-12">
                    <div class="">
                        <div>
                            <div class="display-1 error-text mb-5 font-weight-bold">{{statusCode ? statusCode : 500}}</div>
                            <h1 class="h3  mb-3 font-weight-bold">Sorry, an error has occured, Service Unavaliable </h1>
                            <p class="h5 font-weight-normal mb-7 leading-normal">You may have mistyped the address or the page may have moved.</p>
                            <button class="btn btn-secondary" (click)="helpersService.goToHomeLang()">
                                <i class="fe fe-arrow-left-circle mr-1"></i>Back to home
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>